import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import handleApiError from "../helpers/handleApiError";
import DeliveryConcernSearchForm from "./DeliveryConcernSearchForm";
import useForm from "../hooks/useForm";
import DeliveryConcernTable from "./DeliveryConcernTable";
import {
  getRouteUpdatesForClient,
  getDeliveryConcerns,
} from "../services/deliveryConcernService";
import RouteAlerts from "./RouteAlerts";
import { defaultTitle } from "../config";
import { Helmet } from "react-helmet";
import { format as dateFormat } from "date-fns";
import { DiliTextCP } from "./Utility/DiliTextCP";
import { GleamPanel } from "./Utility/GleamPanel";

const viewStates = {
  success: "success",
  loading: "loading",
  error: "error",
  nodata: "nodata",
};

const RecentRouteUpdates = ({ routeUpdates, viewState, isLoading }) => {
  //   console.log(routeUpdates[0]?.e_Body?.split("Thank you"));
  const sortedRouteUpdates = routeUpdates.sort((a, b) => {
    // console.log(a.entered);
    // console.log(b.entered);
    // console.log(a.entered - b.entered);
    return new Date(b.entered) - new Date(a.entered);
  });

  return (
    <div
      className="container"
      style={{
        backgroundColor: "#e9ecef",
        maxHeight: isLoading ? "200px" : "300px",
        overflow: "auto",
        marginBottom: "50px",
        borderRadius: ".3rem",
      }}
    >
      <h4
        style={{ textAlign: "center", padding: "20px", paddingBottom: "15px" }}
      >
        Route Alerts
      </h4>
      <div style={{ padding: "40px", paddingTop: "0px" }}>
        {viewState === viewStates.success ? (
          sortedRouteUpdates.map((routeUpdate, index) => {
            return (
              <div
                className="row"
                key={index + "-" + routeUpdate}
                style={{
                  boxShadow: "0px 2px 15px rgba(0,0,0,.2)",
                  backgroundColor: "White",
                  marginBottom: "15px",
                  padding: "15px",
                }}
              >
                <div className="col-lg-9 font-500">{routeUpdate.subject}</div>
                <div className="col-lg-3 text-lg-right font-500">
                  {dateFormat(new Date(routeUpdate.entered), "MM/dd/yyyy")}
                </div>
                <div className="col-12 font-500">{routeUpdate.route}</div>
                <div className="col-12">
                  {
                    routeUpdate.e_Body?.split(
                      "Thank you for choosing Diligent"
                    )[0]
                  }
                </div>
              </div>
            );
          })
        ) : viewState === viewStates.loading ? (
          <>
            <GleamPanel
              height={120}
              style={{ marginBottom: "15px" }}
              className="row"
            />
            <GleamPanel
              height={120}
              style={{ marginBottom: "15px" }}
              className="row"
            />
            <GleamPanel
              height={120}
              style={{ marginBottom: "15px" }}
              className="row"
            />
          </>
        ) : viewState === viewStates.nodata ? (
          <div style={{ textAlign: "center" }}>No Route Alerts!</div>
        ) : (
          <div style={{ textAlign: "center" }}>Issue finding route alerts.</div>
        )}
      </div>
    </div>
  );
};

const DeliveryConcernBoard = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  // const [searchFormValues, setSearchFormValues] = useForm({
  //     concernId: 0,
  //     customerName: "",
  //     route: "",
  //     city: "",
  //     shipDate: ""
  // });

  const [deliveryConcerns, setDeliveryConcerns] = useState([]);
  const [routeUpdates, setRouteUpdates] = useState([]);
  const [routeUpdatesViewState, setRouteUpdatesViewState] = useState(
    viewStates.loading
  );

  // const handleSearchSubmit = async (e) => {
  //     e.preventDefault();

  //     setLoading(true);

  //     try {
  //         //how am i supposed to pass the data?
  //         const { data: foundDeliveryConcerns } = await getDeliveryConcerns({
  //             deliveryConcernDto: {
  //                 clientId: -1,
  //                 shippingDate : searchFormValues.shipDate, //keep like this for now (dbl check cnls logic)
  //                 customer: searchFormValues.customerName,
  //                 tranId: searchFormValues.concernId,
  //                 route: searchFormValues.route,
  //                 customerCity: searchFormValues.city //repo doesn't have city logic
  //             }
  //         })
  //         setDeliveryConcerns(foundDeliveryConcerns);

  //         setLoading(false);
  //     }
  //     catch (ex) {
  //         setLoading(false);
  //         handleApiError(ex, history)
  //     }
  // }

  const handleDetailsClick = (deliveryConcernId) => {
    // console.log(deliveryConcernId);

    history.push(`/delivery-concern/${deliveryConcernId}`);
  };

  useEffect(() => {
    (async () => {
      setError(false);
      setLoading(true);

      try {
        setRouteUpdatesViewState(viewStates.loading);
        const { data: foundRouteUpdates } = await getRouteUpdatesForClient();
        const { data: foundDeliveryConcerns } = await getDeliveryConcerns();

        if (foundRouteUpdates?.length === 0) {
          setRouteUpdatesViewState(viewStates.nodata);
        } else {
          setRouteUpdatesViewState(viewStates.success);
        }

        setRouteUpdates(foundRouteUpdates);
        setDeliveryConcerns(foundDeliveryConcerns);
      } catch (ex) {
        setRouteUpdatesViewState(viewStates.error);
        handleApiError(ex, history);
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [history]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Delivery Concerns - {defaultTitle}</title>
      </Helmet>
      <center>
        <h1>Delivery Concerns</h1>
      </center>
      {/* <RouteAlerts setLoading={setLoading} /> */}
      <RecentRouteUpdates
        routeUpdates={routeUpdates}
        viewState={routeUpdatesViewState}
        isLoading={isLoading}
      />
      {/* <div className='my-2'>
                <DeliveryConcernSearchForm 
                    formValues={searchFormValues} 
                    setFormValues={setSearchFormValues}
                    onSubmit={handleSearchSubmit} />
            </div> */}
      <DeliveryConcernTable
        deliveryConcerns={deliveryConcerns}
        onDetailsClick={handleDetailsClick}
        isLoading={isLoading}
        isError={isError}
      />
    </React.Fragment>
  );
};

export default DeliveryConcernBoard;
